import { Action, ActionFunction1 } from "redux-actions";
import { IImportReport } from "../../../api/CourseAuthorApi";
import { IClientPatch, IPatchAction } from "../../../components/course-author/helpers/patches";
import { ISaveInProgressStateProps } from "../../../components/utils/SaveInProgress";
import { IUser } from "../../Analytics/Common";
import { ICompleteOrganization, RequestState } from "../../types/common";

export type ReportRequested = "users" | "assessments";

export interface IFetchInitialData {
  admins: IUser[];
  organization: ICompleteOrganization;
}

export interface IMiddleError {
  scormPackageId: string;
  scormPackageName: string | null;
  message: string;
}

export interface IProgressSteps {
  stepNumber: number;
  totalSteps: number;
}

export interface IErrorMessage {
  message: string;
  uploadType: UploadType;
}

export interface IFetchInitialDataFurtherActions {
  onSuccess: ActionFunction1<IFetchInitialData, Action<IFetchInitialData>>;
  onFailure: ActionFunction1<{ message: string }, Action<{ message: string }>>;
}

export interface IOrganizationSettingsImportFurtherActions {
  onSuccess: ActionFunction1<IImportReport, Action<IImportReport>>;
  onFailure: ActionFunction1<IErrorMessage, Action<IErrorMessage>>;
}

export interface IOrganizationSettingsFurtherActions {
  onSuccess: ActionFunction1<ICompleteOrganization, Action<ICompleteOrganization>>;
  onFailure: ActionFunction1<{ message: string }, Action<{ message: string }>>;
}

export interface IRequestAllTableDataFurtherActions {
  onFinish: ActionFunction1<void, Action<void>>;
  onMiddleError: ActionFunction1<IMiddleError, Action<IMiddleError>>;
  onFatalError: ActionFunction1<{ message: string }, Action<{ message: string }>>;
  onStep: ActionFunction1<IProgressSteps, Action<IProgressSteps>>;
}

export enum SettingsOption {
  Preview = "preview",
  Settings = "settings",
  Import = "import",
  Reports = "reports",
}

export interface ISettingsFile {
  file: File;
  uploadType: UploadType;
}

export type UploadType = "accounts" | "members" | "groups";

export type OrganizationSettingsProps = IOrganizationSettingsStateToProps &
  ISaveInProgressStateProps &
  IOrganizationSettingsDispatchProps;

export interface IOrganizationSettingsDispatchProps {
  patchRequest: (patch: IClientPatch<IPatchAction>) => void;
  uploadCsv: (file: File, uploadType: UploadType) => void;
  mount: () => void;
  unmount: () => void;
}

export interface IOrganizationSettingsStateToProps {
  organization: ICompleteOrganization | null;
  organizationAdmins: IUser[];
  initialTab: SettingsOption;
  isAdmin: boolean;
  organizationName: string;
  userName: string;
  uploadError: IErrorMessage | null;
  accountId: string;
  fetchInitialDataStatus: RequestState;
}
